import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "card-header card-header-stretch" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_4 = { class: "d-flex align-items-center gap-2" }
const _hoisted_5 = {
  class: "text-muted",
  style: {"font-size":"12px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vxe_input = _resolveComponent("vxe-input")!
  const _component_vxe_form_item = _resolveComponent("vxe-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_vxe_button = _resolveComponent("vxe-button")!
  const _component_vxe_form = _resolveComponent("vxe-form")!
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_vxe_pager = _resolveComponent("vxe-pager")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vxe_form, {
        data: _ctx.formData,
        onSubmit: _ctx.submitEvent
      }, {
        default: _withCtx(() => [
          _createVNode(_component_vxe_form_item, {
            field: "mobile",
            "item-render": {}
          }, {
            default: _withCtx(({}) => [
              _createVNode(_component_vxe_input, {
                modelValue: _ctx.formData.mobile,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.mobile) = $event)),
                placeholder: "手机号码"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_date_picker, {
                modelValue: _ctx.duration,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.duration) = $event)),
                type: "datetimerange",
                "range-separator": " - ",
                "start-placeholder": "Start date",
                "end-placeholder": "End date"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_vxe_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_vxe_button, {
                type: "submit",
                status: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "onSubmit"])
    ]),
    _createVNode(_component_vxe_table, {
      data: _ctx.tableData,
      "row-config": { isHover: true }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          field: "id",
          title: "ID"
        }),
        _createVNode(_component_vxe_column, {
          field: "box_info",
          title: "套系"
        }),
        _createVNode(_component_vxe_column, {
          field: "box",
          title: "箱号"
        }),
        _createVNode(_component_vxe_column, {
          title: "用户",
          width: "180"
        }, {
          default: _withCtx(({ row }) => [
            _createElementVNode("div", _hoisted_4, [
              (row.user?.avatar)
                ? (_openBlock(), _createBlock(_component_el_avatar, {
                    key: 0,
                    src: row.user.avatar,
                    size: 32
                  }, null, 8, ["src"]))
                : (_openBlock(), _createBlock(_component_el_avatar, {
                    key: 1,
                    size: 32,
                    icon: "UserFilled"
                  })),
              _createElementVNode("div", null, [
                _createElementVNode("div", null, _toDisplayString(row.user?.nickname || '-'), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(row.user?.mobile || ''), 1)
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "product",
          title: "商品"
        }),
        _createVNode(_component_vxe_column, {
          field: "item_type_display",
          title: "赏品类型"
        }),
        _createVNode(_component_vxe_column, {
          field: "price",
          title: "回收价"
        }, {
          default: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatPrice(row.price)), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_vxe_column, {
          field: "created_at",
          title: "抽赏时间",
          width: "200"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_vxe_pager, {
      "current-page": _ctx.page.currentPage,
      "onUpdate:current-page": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page.currentPage) = $event)),
      "page-size": _ctx.page.pageSize,
      "onUpdate:page-size": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.page.pageSize) = $event)),
      total: _ctx.page.totalResult,
      layouts: [
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total',
      ],
      onPageChange: _ctx.onPageChange
    }, null, 8, ["current-page", "page-size", "total", "onPageChange"])
  ]))
}